export const environmentData = {
  run: "development", // Change this value to "production" for production environment
  development: {
    clientId: "c1842ba4-5674-4d50-8eb1-0740d17a8227",
    authority: "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope": "openid c1842ba4-5674-4d50-8eb1-0740d17a8227/user_impersonation",
    apiBaseURL: "https://hm-oa-insights-api-dev.azurewebsites.net/api",
    heatMapUrl:
      "https://web-oa-iv-insights-dev-gfc3guabcyefc3aq.swedencentral-01.azurewebsites.net",
    openProblemURL:
      "https://app-openmajorproblem-insights-dev-abcdd8h5cdhba8b9.swedencentral-01.azurewebsites.net/OpenMajorProblemInsights",
    businessStructureInsights:
      "https://businessstructure-insights-dev-djc4edc4czc3fmc0.swedencentral-01.azurewebsites.net",
    dataQuality:
      "https://sn-dataquality-healthscores-dev-bxbhd5cac7gkhegv.swedencentral-01.azurewebsites.net",
    github:
      "https://github-dataquality-healthscores-dev-erg2hvffhcbcaff3.swedencentral-01.azurewebsites.net",
    feedback: "https://iip-feedback-dev-gygncvh2c3ezb6gp.swedencentral-01.azurewebsites.net",
    logistics: "https://logistics-app-c3g3gahvc8gxdra0.swedencentral-01.azurewebsites.net",
    peakSeason:
      "https://peak-season-inights-dev-ajb9ffd2deg9b4d6.swedencentral-01.azurewebsites.net",
    mcirtPeakSeason:
      "https://peak-season-inights-dev-ajb9ffd2deg9b4d6.swedencentral-01.azurewebsites.net",
    geographyBT:
      "https://iip-geographicalview-dev-gsamc2aredgqhsbu.swedencentral-01.azurewebsites.net",
    storeHealthHeatMap:
      "https://storeops-heatmap-dev-hbdncyc9d3f0bghp.swedencentral-01.azurewebsites.net",
    businessImpact:
      "https://businessstructure-insights-dev-djc4edc4czc3fmc0.swedencentral-01.azurewebsites.net",
    businessCapability:
      "https://hm-oa-business-capability-api-bgcjfjf2e9drcdb5.swedencentral-01.azurewebsites.net",
    shopUrl:
      "https://hm-oia-stability-dashboard-dev-exc4eyg2atfbe9e4.swedencentral-01.azurewebsites.net/",
    businessCapabilityInsights:
      "https://business-capability-api-dev-fdeka8g0eyfmadgx.swedencentral-01.azurewebsites.net",
    problemManagementSolution:
      "https://problem-management-solution-test-e4hvefd8bfgfgsha.swedencentral-01.azurewebsites.net/",
    drillDownReport:
      "https://hm-oa-incident-drilldown-dashboard-fdg0gjaac6hyfpff.swedencentral-01.azurewebsites.net",
    beaconAgent: "https://ars-beacon-agent.azurewebsites.net",
    itsmDashboard:
      "https://hm-oia-itsm-dashboard-dev-cmh8g3g7ayhjfuc3.swedencentral-01.azurewebsites.net",
    appUrl: "https://intelligentinsights.az.hmgroup.tech",
  },
  production: {
    clientId: "369a0357-3b42-434c-8941-862aecc6f59f",
    authority: "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope": "openid 369a0357-3b42-434c-8941-862aecc6f59f/user_impersonation",
    apiBaseURL:
      "https://hm-oa-insights-api-prod-gudzcdghf2g3drbk.swedencentral-01.azurewebsites.net/api",
    heatMapUrl:
      "https://web-oa-iv-insights-prod-hjb6e7fqhcaag0hs.swedencentral-01.azurewebsites.net",
    openProblemURL:
      "https://app-openmajorproblem-insights-prod-c7fdbbhbb6f8f9dh.swedencentral-01.azurewebsites.net/OpenMajorProblemInsights",
    businessStructureInsights:
      "https://businessstructure-insights-prod-hucjdcasa3a5bha6.swedencentral-01.azurewebsites.net",
    dataQuality:
      "https://sn-dataquality-healthscores-prod-f4g3cne0gmcjebaw.swedencentral-01.azurewebsites.net",
    github:
      "https://github-dataquality-healthscores-prod-eph3dycde5guhpd6.swedencentral-01.azurewebsites.net",
    feedback: "https://iip-feedback-prod-gwfqddhud5ddf6az.swedencentral-01.azurewebsites.net",
    logistics: "https://logistics-app-prod-h4hqbbevbza7f7hp.swedencentral-01.azurewebsites.net",
    peakSeason:
      "https://peak-season-inights-dev-ajb9ffd2deg9b4d6.swedencentral-01.azurewebsites.net",
    mcirtPeakSeason:
      "https://peak-season-insights-prod-czdggjabf7cya8ce.swedencentral-01.azurewebsites.net",
    geographyBT:
      "https://iip-geographicalview-prod-e0dpdca2fvfyhtdn.swedencentral-01.azurewebsites.net",
    storeHealthHeatMap:
      "https://storeops-heatmap-prod-gfehaxc3guhpamd0.swedencentral-01.azurewebsites.net",
    businessImpact:
      "https://businessstructure-insights-dev-djc4edc4czc3fmc0.swedencentral-01.azurewebsites.net",
    businessCapability:
      "https://hm-oa-business-capability-api-prod-dmgwhdbhgchwdxab.swedencentral-01.azurewebsites.net",
    shopUrl:
      "https://hm-oia-stability-dashboard-prod-ggbacme4e8hfaxb4.swedencentral-01.azurewebsites.net",
    businessCapabilityInsights:
      "https://business-capability-api-prod-ayhbb3fnhbfyfkfg.swedencentral-01.azurewebsites.net",
    problemManagementSolution:
      "https://problem-management-solution-prod-esddbdfdf2fkephn.westeurope-01.azurewebsites.net/",
    drillDownReport:
      "https://hm-oa-incident-drilldown-dashboard-prod-cngfc0fpeegyc4ac.swedencentral-01.azurewebsites.net",
    beaconAgent: "https://ars-beacon-agent-prod.azurewebsites.net",
    itsmDashboard:
      "https://hm-oia-itsm-dashboard-prod-b3hadvh3efb5b8h6.swedencentral-01.azurewebsites.net",
    appUrl: "https://intelligentinsights.hmgroup.com",
  },
}

export const shopUrl = environmentData[environmentData.run].shopUrl
export const appUrl = environmentData[environmentData.run].appUrl
